import GET_ARTICLES from '../plugins/getArticles'


export default function HOME() {
  const w = window
  w.jQuery = $

  $(() => {
  
    // トップページカスタム
    $.topInit();
  
    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'topics':{
        button:{
          disp: true,
          text: 'VIEW ALL',
          attr: {
            class: 'button button-inverse c-btn-icon-right'
          }
        },
        title:{
          html: '<span>NEWS</span><small>新着情報</small>' // プレーンテキストで動的にする場合は false
        },
        itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
          $this
            .append( $title.append($new) )
            .append( $catetitle )
            .append( $date )
            .append( $catch )
            .append( $body );
          // $date.insertAfter( $catetitle );
        }
      },
      // 'works':{
      //   title:{
      //     html: '<span>WORKS</span><small>施工事例</small>' // プレーンテキストで動的にする場合は false
      //   },
      //   itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
      //     $this
      //       .append( $title.append($new) )
      //       .append( $catetitle )
      //       .append( $date )
      //       .append( $catch )
      //       .append( $body );
      //     // $date.insertAfter( $catetitle );
      //   }
      // },
    }));

  })
  
  $(() => {
    /****************************
     * movie background
     */
    $.when(
      w.load['mainvisual'],
      $.getScript('/asset/js/vendor/jquery.mb.YTPlayer.min.js')
      ).done(()=>{
      const $MV = $('[data-plugin="ytplayer"]')
      const param = id => `{
        videoURL: '${id}',
        containment: '${($.UA.is_mobile)? '.p-mainvisual__bg__wrap': '.p-mainvisual'}',
        mute: true,
        showControls: false,
        autoPlay: true,
        useOnMobile: true,
        showYTLogo: false,
        abundance: 0.07,
        stopMovieOnBlur: false,
        loop: true,
        startAt: 0,
        anchor: '${($.UA.is_mobile)? 'bottom,center' :'center,center'}',
        quality: '${($.UA.is_mobile)? 'default': 'hd1080'}'
      }`.replace(/\n|\s/g,'')
      $MV.attr('data-property',param('JOt_XVc6K7I'));
      $MV.YTPlayer()
      $MV.YTPPlay()
      // スクロールボタンをクリックで画面の高さ分スクロール
      $('.p-mainvisual__scroll').on('click',()=>{
        const width = $(window).innerWidth()
        const scrollheight = width * 0.65
        $('body,html').animate({scrollTop: scrollheight },'fast','easeInOutExpo')
        return false
      })
    })

    // pickup
    $.when(
      $.getFreeBlock({id: 2 }),
      w.load['mainvisual']
    ).then( res => {
      const $link = $('a[href]:eq(0)', `<div>${res}</div>` )
      const $container = $(`
        <div class="conceptelement">
          <div class="p-pickup-inner">
            <h3 class="p-pickup-title"><span>PICK UP</span><img src="/asset/img/top/pickup_txt.png" alt="PICKUP" width="74" /></h3>
            <a class="p-pickup-link" href="${$link.attr('href')}">
              <div class="p-pickup-item">${$link.text().str_truncate(45)}</div>
              <!-- /.p-pickup-item -->
              <div class="p-pickup-arrow"><em class="fas fa-chevron-right"></em></div>
            </a>
          </div>
          <!-- /.p-pickup-inner -->
        </div>
      `)
      $('.element.conceptelement','#main').parents('.block.block_head').remove()
      if( $link != undefined ) $('.p-mainvisual').parent().css('position','relative').append( $container )
    })

    w.load['block-about'].done(() => {
      GET_ARTICLES('.p-block-news [data-plugin="getArticles"]',{
        makeItem(item){
          return $(`
          <a href="${item.href}" class="p-block-news__item">
            <div class="p-block-news__item-inner">
              <figure class="thumb" style="background-image:url('${item.thumb}')">
                <img src="${item.thumb}" width="204" alt="${item.title}">
              </figure>
            </div>
            <div class="body">
              <span class="category cat-${( '0' + item.category.id ).slice(-2)}">${item.category.name}</span>
              <small class="date">${item.date}</small>
              <span class="title">
                ${item.title}
              </span>
            </div>
          </a>
        `)[0]
        }
      });
    })
  
  });


}